import {
  AfterContentInit,
  Component,
  OnDestroy,
  OnInit,
  TemplateRef,
  ViewChild,
  ViewContainerRef
} from '@angular/core';
import {LoaderService} from '../../../../services/loader.service';
import {Subject} from 'rxjs';
import {animate, keyframes, transition, trigger} from '@angular/animations';
import * as kf from '../../../../animations/keyframes';
import {takeUntil} from 'rxjs/operators';

/**
 * This is a universal loader component holding multiple presets along with default one
 */
@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss'],
  animations: [
    trigger('fade', [
      transition('* => void', animate(500, keyframes(kf.fadeOut)))
    ])
  ]
})
export class LoaderComponent implements OnInit, AfterContentInit, OnDestroy {
  @ViewChild('mapPreset', {static: true}) mapPreset: TemplateRef<any>;
  @ViewChild('cardPreset', {static: true}) cardPreset: TemplateRef<any>;
  @ViewChild('tablePreset', {static: true}) tablePreset: TemplateRef<any>;
  @ViewChild('defaultPreset', {static: true}) defaultPreset: TemplateRef<any>;
  @ViewChild('loaderOutlet', {read: ViewContainerRef, static: true}) loaderOutlet: ViewContainerRef;

  zIndex = 1000;
  presets: any = {};
  chosenTemplate: TemplateRef<any>;

  isVisible = true;

  destroy$: Subject<boolean> = new Subject();

  constructor(public loader: LoaderService) {
  }

  ngOnInit() {
    this.loader.loading$.pipe(takeUntil(this.destroy$)).subscribe(isLoading => this.isVisible = isLoading);
  }

  ngAfterContentInit(): void {
    this.presets = {
      mapPreset: this.mapPreset,
      cardPreset: this.cardPreset,
      tablePreset: this.tablePreset,
      defaultPreset: this.defaultPreset,
    };

    if (typeof this.chosenTemplate === 'string' && this.presets.hasOwnProperty(this.chosenTemplate)) {
      this.chosenTemplate = this.presets[this.chosenTemplate];
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }
}
